import { render } from "./NavBar.vue?vue&type=template&id=fac1a10e&scoped=true"
const script = {}

import "./NavBar.vue?vue&type=style&index=0&id=fac1a10e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/meedly-vueportfolio/meedly-vueportfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fac1a10e"]])

export default __exports__